import { SidebarButton } from '../model/sidebar-button.type';
import { SvgDataModelComponent } from '../svg/svg-data-model.component';
import { SvgDocumentationComponent } from '../svg/svg-documentation.component';
import { SvgFileGeneratorComponent } from '../svg/svg-file-generator.component';
import { SvgHomeComponent } from '../svg/svg-home.component';
import { SvgLogoutComponent } from '../svg/svg-logout.component';
import { SvgProjectComponent } from '../svg/svg-project.component';
import { SvgSequenceDiagramComponent } from '../svg/svg-sequence-diagram.component';
import { SvgSettingsComponent } from '../svg/svg-settings.component';

const GENERAL_BUTTONS: SidebarButton[] = [
  {
    label: 'Accueil',
    link: '/',
    svg: SvgHomeComponent,
  },
  {
    label: 'Projets',
    link: '/dashboard',
    svg: SvgProjectComponent,
  },
];

const PROJECTS_BUTTONS: SidebarButton[] = [
  {
    label: 'Diagramme de séquence',
    link: '/sequence-diagram',
    svg: SvgSequenceDiagramComponent,
  },
  {
    label: 'Modèle de données',
    link: '/database-model/menu',
    svg: SvgDataModelComponent,
  },
  {
    label: 'Java vers UML',
    link: '/umljava',
    svg: SvgFileGeneratorComponent,
  },
];

const DOCUMENTATION_BUTTONS: SidebarButton[] = [
  {
    label: 'Documentation',
    link: '/documentation',
    svg: SvgDocumentationComponent,
  },
];

const OPTION_BUTTONS: SidebarButton[] = [
  {
    label: 'Réglages',
    link: '/settings',
    svg: SvgSettingsComponent,
  },
  {
    label: 'Se déconnecter',
    link: '/',
    svg: SvgLogoutComponent,
  },
];

export const SIDEBAR_BUTTONS: SidebarButton[][] = [GENERAL_BUTTONS, PROJECTS_BUTTONS, DOCUMENTATION_BUTTONS, OPTION_BUTTONS];
